export const Data = [
  {
    type: "zh",
    content: {
      gsxwTatle:"公司新闻",
      gsxwMore:"查看更多",
      gsxwItem:[
        {
          imgUrl:"http://116.62.38.250//image/sy/news1.jpg",
          text1:"2024年3月19日",
          text2:"口腔 Er:YAG激光治疗仪2024... ",
          text3:"了解更多",
          indexPath:"gss",
          backcolor:"#FFFFFF"
        },
        {
          imgUrl:"http://116.62.38.250//image/sy/news2.jpg",
          text1:"2024年3月20日",
          text2:"2024年东北国际口腔展隆重...",
          text3:"了解更多",
          indexPath:"gxx",
          backcolor:"#FFFFFF"
        },
        {
          imgUrl:"http://116.62.38.250//image/sy/news3.jpg",
          text1:"2024年3月27日",
          text2:"微创未来 3月郑州有请",
          text3:"了解更多",
          indexPath:"gyy",
          backcolor:"#FFFFFF"
        }
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/js/image/gsxw.js